import { fmt } from "@/poker/cards";
import { blindsFor, STREET_LABEL } from "@/poker/engine";
import { LogOut, ScrollText } from "lucide-react";

const Stat = ({ label, value, testId }) => (
  <div className="flex flex-col leading-tight">
    <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500">{label}</span>
    <span data-testid={testId} className="font-mono text-sm sm:text-base font-bold text-slate-100">{value}</span>
  </div>
);

export const Hud = ({ game, onQuit, onOpenLog }) => {
  const alive = game.players.filter((p) => !p.out);
  const avg = alive.reduce((a, p) => a + p.stack + p.totalBet, 0) / alive.length;
  const next = blindsFor(game.cfg, game.level + 1);
  const left = game.cfg.handsPerLevel - ((game.handNum - 1) % game.cfg.handsPerLevel);
  return (
    <div data-testid="blind-level-hud" className="flex items-center gap-4 sm:gap-8 flex-wrap px-4 sm:px-6 py-3 border-b border-white/5 bg-[#0d0f15]/90 backdrop-blur-xl">
      <span className="font-heading text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-amber-400 mr-auto sm:mr-0">Hold'em Trainer</span>
      <Stat label="Level" value={game.level + 1} testId="hud-level" />
      <Stat label="Blinds" value={`${fmt(game.sb)}/${fmt(game.bb)}`} testId="hud-blinds" />
      <Stat label="Next" value={`${fmt(next.sb)}/${fmt(next.bb)} in ${left}`} testId="hud-next-level" />
      <Stat label="Hand" value={`#${game.handNum} · ${STREET_LABEL[game.street]}`} testId="hud-hand" />
      <Stat label="Players" value={`${alive.length}/${game.players.length}`} testId="hud-players-left" />
      <Stat label="Avg stack" value={fmt(avg)} testId="hud-avg-stack" />
      <button data-testid="toggle-log-button" onClick={onOpenLog} className="lg:hidden ml-auto p-1.5 rounded-lg border border-white/10 text-slate-300"><ScrollText size={16} /></button>
      <button data-testid="quit-tournament-button" onClick={onQuit} className="lg:ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-white/10 text-xs text-slate-400 hover:text-white hover:border-red-500/60 transition-colors">
        <LogOut size={14} /> Quit
      </button>
    </div>
  );
};
